import { Box, CircularProgress, Divider, Grid, Typography } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useReactToPrint } from "react-to-print";
import WSButton from "../../Components/Button/WSButton";

import { callAPI, dateFormat, formatIndianCurrency, getLocalValue, LoacalVariables, Method } from "../../commonFunctions/CommonFunctions";
import { useSnackbar } from "../../Components/Snackbar/SnackBarContext";
import logo from '../../images/logo.svg';
import { IBranch } from "../DTO/Dto";
import { NotFound } from "../NotFound";
import dayjs from "dayjs";
const PartPaymentPrint: React.FC<any> = () => {
    const { id } = useParams();
    const contentRef = useRef<HTMLDivElement>(null);
    const { showMessage } = useSnackbar();

    const [data, setData] = useState<any>(null);
    const [loading, setLoading] = useState<boolean>(true);
    const [branchData, setBranchData] = useState<IBranch>()

    // const navigate = useNavigate();
    // const routerLocation  = useLocation();

    // const handleCancel = () => {
 
    //     const from = routerLocation .state?.from || "/";
    //     const scrollY = routerLocation .state?.scrollY || 0;
    //     navigate(from);
    //     setTimeout(() => window.scrollTo({ top: scrollY, behavior: "smooth" }), 200);
    // };
    useEffect(() => {
        async function getDataById() {
            try {
                const response: any = await callAPI("Partpayment", Method.GET, null, id);
                if (response) {
                    setData(response || undefined);
                }
            } catch (error) {
                showMessage("Something went wrong. Please try again.", "error");
            } finally {
                setLoading(false);
            }
        }
        async function getBranchDetails() {
            try {
                const response: any = await callAPI("Branch", Method.GET, null, getLocalValue(LoacalVariables.Branch));
                if (response?.data) {
                    setBranchData(response.data);
                }
            } catch (error) {
                showMessage("Something went wrong. Please try again.", "error");
            } finally {
                setLoading(false);
            }
        }
        if (id) {
            getDataById();
            getBranchDetails()
        }
    }, [id]);

    // 🖨️ Print Handler
    const handlePrint = useReactToPrint({
        contentRef
    });

    if (loading)
        return (
            <Box display="flex" justifyContent="center" mt={4}>
                <CircularProgress />
            </Box>
        );
    if (!data) return <NotFound />;
    return (
        <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            p={4}
            bgcolor="grey.100"
            minHeight="100vh"
        > 
        {/* <WSButton
                id="back"
                size="small"
                label="Cancel"
                onClick={handleCancel}
            /> */}
            <WSButton
                id="printBtn"
                size="small"
                label="Print"
                onClick={handlePrint}
            />

            <Box
                ref={contentRef}
                mt={2}
                sx={{ p: 4, width: "100%", maxWidth: "800px", bgcolor: "white" }}
            > <Box ml={2} display={'flex'} justifyContent={'flex-end'}>
                    <img src={logo} alt="Company Logo" style={{ objectFit: "contain" }} />
                </Box>
                {/* Company Header */}

                <Box textAlign="center" borderBottom={1} pb={2} mb={2}>
                    <Typography variant="h4" fontWeight="bold" color="error" fontStyle={'italic'}>
                        {branchData?.name}
                    </Typography>
                    <Typography variant="body2">
                        {branchData?.address?.addressLine1}   {branchData?.address?.addressLine2 || ''} P.O {branchData?.address?.pincode}
                    </Typography>
                    <Typography variant="body2">{`PH: ${branchData?.phoneNumber},${branchData?.alternatePhoneNumber || ''}`}</Typography>
                </Box>

                {/* Estimate Details */}
                <Grid container justifyContent="space-between" mb={1}>
                    {/* Left side: Customer Details */}
                    <Grid item xs={6}>
                        <Box textAlign="left">
                            <Typography sx={{ fontSize: '0.875rem' }}>
                                To,
                            </Typography>
                            <Typography sx={{ fontSize: '0.875rem', paddingLeft: 2 }}>
                                {data.customerName}
                            </Typography>
                            <Typography sx={{ fontSize: '0.875rem', paddingLeft: 2 }}>
                                Site at {data.address}.
                            </Typography>
                        </Box>
                    </Grid>

                    {/* Right side: Quote No & Date */}
                    <Grid item xs="auto">
                        <Box textAlign="right">
                            {/* <Typography sx={{ fontSize: '0.875rem', paddingLeft: 2 }} align="left">
                                Quote No : {data.quotationNumber}
                            </Typography> */}
                            <Typography sx={{ fontSize: '0.875rem', paddingLeft: 2 }} align="left">
                                Date : {dateFormat(data.date, 'DD-MM-YYYY')}
                            </Typography>
                        </Box>
                    </Grid>
                </Grid>

                {/* Estimation Details */}
                <Box textAlign="center" mb={2} sx={{ fontSize: '0.875rem', fontWeight: 'bold' }}>
                    <Typography sx={{ fontSize: '1rem', fontWeight: 'bold' }}>Part payment request</Typography>
                </Box>

                <Box mb={2}>
                    <Typography sx={{ fontSize: '0.875rem' }}>Dear Sir/Madam</Typography>
                    <Typography sx={{ fontSize: '0.875rem', mt: 2 }}>
                        {data.description.replace("@amount", `( ${data?.amount}/ )`).replace("@area", `${data?.area}`)}
                    </Typography>
                </Box>
                {/* Footer */}
                <Divider sx={{ my: 3 }} />
                <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="flex-end"
                >
                    <Box textAlign="right" sx={{ flex: 1, justifyContent: 'flex-end' }}>
                        <Typography sx={{ fontSize: '0.875rem' }}>Thanks with kind Regards</Typography>
                        <Typography fontWeight="bold" sx={{ fontSize: '0.875rem' }}>JOSEPH PJ</Typography>
                        <Typography sx={{ fontSize: '0.875rem' }}>Managing Director</Typography>
                        <Typography sx={{ fontSize: '0.875rem' }}> {branchData?.name}</Typography>
                    </Box>
                </Box>
            </Box>

        </Box>
    );
};

export default PartPaymentPrint;
